/**
 * The one-line bridge between the API client and the auth state.
 *
 * The client is constructed before any React tree exists and takes `onSessionExpired` as a
 * constructor option; the auth provider is a component that mounts later and wants to know.
 * Rather than threading a mutable ref through four providers, the client shouts into this bus
 * and whoever is listening reacts.
 *
 * It fires only when a 401 could NOT be recovered by refreshing — an ordinary expired access
 * cookie is refreshed and replayed silently and never reaches here, which is what keeps a
 * working session from being bounced to the login screen.
 */

type Listener = () => void;

const listeners = new Set<Listener>();

export function onSessionExpired(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitSessionExpired(): void {
  for (const listener of [...listeners]) listener();
}

/** Test seam: forget every listener between cases. */
export function resetSessionExpiryListeners(): void {
  listeners.clear();
}
